import { ActGlo, ActSyn } from '../App_Data/ActionTypes';

const initialState = {
    Syn: ActGlo.EN_COURS_DE_CHARGEMENT,
};

function SynStore(state = initialState, action) {
    switch (action.type) {
    case ActGlo.RESET_STORE:
    case ActGlo.CHANGE_COP_SEL:
        return initialState;
    case ActSyn.SYN_AJOUT:
        return {
            ...state,
            Syn: action.data,
        };
    default:
        return state;
    }
}

export default SynStore;



// WEBPACK FOOTER //
// ./src/Reducers/SynStore.js